/**
 * Maps a merchant name to a spending category.
 * Returns one of: 'Travel' | 'Groceries' | 'Entertainment' | 'Home' | 'Other'
 */
export function categorizeTransaction(merchant) {
  const m = merchant.toLowerCase();
  if (m.includes('shell') || m.includes('uber') || m.includes('transit'))                       return 'Travel';
  if (m.includes('shopper') || m.includes('pharmacy') || m.includes('mart'))                    return 'Groceries';
  if (m.includes('pony') || m.includes('itunes') || m.includes('netflix'))                      return 'Entertainment';
  if (m.includes('payment') || m.includes('hydro') || m.includes('rent'))                       return 'Home';
  return 'Other';
}
